import { render } from "./YebPwdSetting.vue?vue&type=template&id=3f2a4eb4&scoped=true"
import script from "./YebPwdSetting.vue?vue&type=script&lang=js"
export * from "./YebPwdSetting.vue?vue&type=script&lang=js"

import "./YebPwdSetting.vue?vue&type=style&index=0&id=3f2a4eb4&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2a4eb4"]])

export default __exports__